import React, { useRef } from "react";
import { RiRefreshLine } from "react-icons/ri";
import "./Dashboard.scss";
import "./RefreshIcon.scss";

const RefreshIcon = ({ handleRefetch, loading }) => {
  const Refresh_icon_ref = useRef(null);

  const handleClick = () => {
    if (!loading) {
      handleRefetch();
    }
  };

  return (
    <div ref={Refresh_icon_ref} onClick={handleClick} style={{ borderRadius: "50%" }}>
      <RiRefreshLine
        size={20}

        className={`icon_styling delete_icon_style FiRefreshCcw ${loading ? "rotatingIcon" : ""}`}
      />
    </div>
  );
};

export default RefreshIcon;
